import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  // existing — DO NOT REMOVE
  'createNewProjectClick',
  'newTranslationProjectSelected',
  'newRecordingProjectSelected',
  'extensionInstallPromptViewed',
  'extensionInstallClicked',
  'extensionInstallSuccess',
  'extensionDetected',
  'extensionOpened',
  'recordingPageViewed',
  'recordingStatusCompleted',
  'recordingStatusFailed',
  'recordingStatusAborted',
  'recordingTabSwitched',
  'recordingDownloadClicked',
  'recordingDownloadCompleted',
  'recordingDownloadFailed',
  'recordingRetryClicked',
  'recordingRated',
  'recordingFeedbackClicked',
  // new — added per analytics.md spec 2026-05-06
  'recordingSignUp',
  'recordingSignIn',
  'recordingAuthenticate',
  'desktopRequiredStateShown',
  'chromeRequiredStateShown',
  'recordingStartFromDashboardClickEntryPoint',
  'recordingStartFromExtensionClickEntryPoint',
  'extensionInstallClick',
  'extensionInstallPromptDismiss',
  'extensionSignInPromptViewed',
  'extensionSignInPromptProceedClick',
  'extensionSignInPromptCanceled',
  'extensionSignInSuccessful',
  'recordingProjectProcessingScreenViewed',
  'recordingProjectProcessingFailed',
  'recordingProjectProcessingSucceeded',
  'recordingProjectResultScreenViewed',
  'recordingProjectExportClick',
  'recordingProjectDownloadClick',
  'recordingProjectDownloadSuccess',
  'recordingProjectShareClick',
  'recordingEditorOpened',
  'transcriptSpeechSegmentRemoved',
  'transcriptSpeechSegmentRestored',
] as const;

export const screenRecordEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
